// assets/logo-slider.js

export default function initLogoSlider(sectionId) {
  // Warte, bis Splide geladen ist
  if (typeof window.Splide !== 'function') return;

  const selector = `#LogoSlider-${sectionId}`;
  const sliderEl = document.querySelector(selector);
  if (!sliderEl) return;

  new window.Splide(sliderEl, {
    type: 'loop',
    perPage: 6,
    gap: '2rem',
    autoplay: true,
    interval: 3000,
    pauseOnHover: true,
    arrows: false,
    pagination: false,
    breakpoints: {
      768: { perPage: 1, gap: '1rem' }
    }
  }).mount();
}

// Direkt beim Laden aufrufen
document.addEventListener('DOMContentLoaded', () => {
  // Suche alle Slider-Sections und initialisiere sie
  document.querySelectorAll('[id^="LogoSlider-"]').forEach(el => {
    const sectionId = el.id.replace('LogoSlider-', '');
    initLogoSlider(sectionId);
  });
});
